import { Route, Routes } from "react-router-dom";
import C3Portfolios from "./C3Portfolios/main";
import C3Transactions from "./C3Transactions/main";
import C3TimeSeries from "./C3TimeSeries/main";
import C3StaticData from "./C3StaticData/main";
import C3Positions from "./C3Positions/main";
import C3DedicatedFunds from "./C3DedicatedFunds/main";
import C3DataUpload from "./C3DataUpload/main";
import C3Exports from "./C3Exports/main";
import C3BankPositions from "./C3BankPositions/main";
import { Tables } from "@/gen/tableNames/tables";
import { ClientTables } from "@/lib/clientTables";

export default function C3Routes() {
  return (
    <Routes>
      <Route path={`${Tables.C3_PORTFOLIOS}/*`} element={<C3Portfolios />} />
      <Route
        path={`${Tables.C3_TRANSACTIONS}/*`}
        element={<C3Transactions />}
      />
      <Route path={`${Tables.C3_TIME_SERIES}/*`} element={<C3TimeSeries />} />
      <Route path={`${Tables.C3_STATIC_DATA}/*`} element={<C3StaticData />} />
      <Route path={`${Tables.C3_POSITIONS}/*`} element={<C3Positions />} />
      <Route
        path={`${Tables.C3_DEDICATED_FUNDS}/*`}
        element={<C3DedicatedFunds />}
      />
      <Route
        path={`${Tables.C3_BANK_POSITIONS}/*`}
        element={<C3BankPositions />}
      />
      <Route
        path={`${ClientTables.C3_DATA_UPLOAD}/*`}
        element={<C3DataUpload />}
      />
      <Route path="c3_exports/*" element={<C3Exports />} />
    </Routes>
  );
}
